<template>
  <div class="navigator">
    <ul class="w-full">
      <base-navigator-item v-for="(navigable, index) in navigables"
         :to="navigable.id" :key="'navigable_'+index"
         >#{{navigable.text}}'</base-navigator-item>
    </ul>
  </div>
</template>

<script>
import BaseNavigatorItem from './BaseNavigatorItem'
export default {
  name: 'BaseNavigator',
  components: { BaseNavigatorItem },
  props: { navigables: { type: Array } },
  data () {
    return { navItems: [] }
  }
}
</script>

<style scoped>
.navigator {
  @apply fixed;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}
</style>
